import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLoaderTitle } from "./styles"; 

const LoaderTitle: React.FC = () => {
  const { t } = useTranslation();
  const text = t("guests.salonSearchMap.allSalonsWillBeDisplayedSoon");

  return <StyledLoaderTitle>{text}</StyledLoaderTitle>;
};

export default LoaderTitle;
